import axiosRequestInterceptor from "../interceptor/axiosAPIRequestInterceptor";
import { useState } from "react";

export const useForgotLogin = () => {



  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  const sendOTPToEmail = async (email) => {
    try {
        setLoading(true);
        const response = await axiosRequestInterceptor.post(`/users/sendOrResendOtpForForgotPassword`, {
			email: email,
		});
        if (response.status >= 200 && response.status < 300) {
            return true;
        } else {
            throw new Error("Failed to send OTP to email");
        }
    } catch (error) {
      setError(error.response.data.error);
      return false;
    } finally {
        setLoading(false);
    }
  };

  const verifyOTP = async (email, otp) => {
    try {
        setLoading(true);
        const response = await axiosRequestInterceptor.post(`/users/verifyOTP`, {
            email: email,
            otp: otp,
        });
        if (response.status >= 200 && response.status < 300) {
            return true;
        } else {
            throw new Error("Failed to verify OTP");
        }
    } catch (error) {
      setError(error.response.data.error);
      return false;
    } finally {
        setLoading(false);
    }
  };

  const resetPassword = async (email, newPassword) => {
    try {
        setLoading(true);
        const response = await axiosRequestInterceptor.post(`/users/resetPassword`, {
            email: email,
            newPassword: newPassword,
        });
        if (response.status >= 200 && response.status < 300) {
            return true;
        } else {
            throw new Error("Failed to reset password");
        }
    } catch (error) {
      setError(error.response.data.error);
      return false;
    } finally {
        setLoading(false);
    }
  };
  
  

  return { sendOTPToEmail, loading, error, setError, verifyOTP, resetPassword };
};

export default useForgotLogin;